import { render, staticRenderFns } from "./search.vue?vue&type=template&id=b3de6d38"
import script from "./search.js?vue&type=script&lang=js&external"
export * from "./search.js?vue&type=script&lang=js&external"
import style0 from "./search.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports